/**
 * The media time Remotion shows for a composition frame of a media layer.
 *
 * `frame` is media-relative: a layer's trim is applied by an outer
 * `<Sequence from={-startFrame}>`, so the layer's first visible composition
 * frame reads as `startFrame` here. `playbackRate` is the same constant
 * multiplier Remotion's <Video> advances the clip by.
 *
 * Shared so that everything showing a frame of a clip agrees on which one:
 * the player, a still, and a timeline lane cover.
 */
export function mediaTimestampSeconds({
  frame,
  fps,
  playbackRate,
}: {
  frame: number;
  fps: number;
  playbackRate?: number;
}): number {
  return Math.max(0, (frame * (playbackRate ?? 1)) / fps);
}
